// export const stateCityData = {
//     "Andaman and Nicobar Islands": [
//         "Bamboo Flat",
//         "Barren Island",
//         "Garacharma",
//         "Havelock",
//         "Mayabunder",
//         "Neil Island",
//         "Port Blair",
//         "Rangat"
//     ],
//     "Andhra Pradesh": [
//         "Adoni",
//         "Amalapuram",
//         "Anakapalle", 
//         "Anantapur",
//         "Bhimavaram",
//         "Chilakaluripet",
//         "Chittoor",
//         "Eluru",
//         "Gooty",
//         "Gudivada",
//         "Guntur",
//         "Hindupur",
//         "Kadapa",
//         "Kakinada",
//         "Kurnool",
//         "Machilipatnam",
//         "Madanapalle",
//         "Nandyal",
//         "Narasaraopet",
//         "Nellore",
//         "Ongole",
//         "Proddatur",
//         "Rajahmundry",
//         "Srikakulam",
//         "Tadepalligudem",
//         "Tenali",
//         "Tirupati",
//         "Vijayawada",
//         "Visakhapatnam",
//         "Vizianagaram"
//     ],
//     "Arunachal Pradesh": [
//         "Aalo",
//         "Bomdila",
//         "Changlang",
//         "Daporijo",
//         "Itanagar",
//         "Naharlagun",
//         "Pasighat",
//         "Roing",
//         "Tawang",
//         "Ziro"
//     ],
//     "Assam": [
//         "Barpeta",
//         "Bongaigaon",
//         "Dhubri",
//         "Dibrugarh",
//         "Diphu",
//         "Goalpara",
//         "Guwahati",
//         "Jorhat",
//         "Karimganj",
//         "Nagaon",
//         "Silchar",
//         "Tezpur",
//         "Tinsukia"
//     ],
//     "Bihar": [
//         "Arrah",
//         "Aurangabad",
//         "Bagaha",
//         "Begusarai",
//         "Bettiah",
//         "Bhagalpur",
//         "Bihar Sharif",
//         "Buxar",
//         "Chhapra",
//         "Darbhanga",
//         "Gaya",
//         "Hajipur",
//         "Katihar",
//         "Motihari",
//         "Munger",
//         "Muzaffarpur",
//         "Patna",
//         "Purnia",
//         "Saharsa",
//         "Samastipur",
//         "Sitamarhi",
//         "Siwan"
//     ],
//     "Chhattisgarh": [
//         "Ambikapur",
//         "Bhilai",
//         "Bilaspur",
//         "Dhamtari",
//         "Durg",
//         "Jagdalpur",
//         "Korba",
//         "Raigarh",
//         "Raipur",
//         "Rajnandgaon"
//     ],
//     "Delhi": [
//         "Central Delhi",
//         "East Delhi",
//         "New Delhi",
//         "North Delhi",
//         "North East Delhi",
//         "North West Delhi",
//         "South Delhi",
//         "South West Delhi",
//         "West Delhi"
//     ],
//     "Goa": [
//         "Mapusa",
//         "Margao",
//         "Mormugao",
//         "Panaji",
//         "Ponda",
//         "Vasco da Gama"
//     ],
//     "Gujarat": [
//         "Ahmedabad",
//         "Anand",
//         "Bhavnagar",
//         "Bharuch",
//         "Gandhinagar",
//         "Jamnagar",
//         "Junagadh",
//         "Mehsana",
//         "Morbi",
//         "Nadiad",
//         "Navsari",
//         "Porbandar",
//         "Rajkot",
//         "Surat",
//         "Vadodara",
//         "Vapi",
//         "Veraval"
//     ],
//     "Haryana": [
//         "Ambala",
//         "Bahadurgarh",
//         "Bhiwani",
//         "Faridabad",
//         "Gurgaon",
//         "Hisar",
//         "Karnal",
//         "Kurukshetra",
//         "Panipat",
//         "Rewari",
//         "Rohtak",
//         "Sonipat",
//         "Yamunanagar"
//     ],
//     "Himachal Pradesh": [
//         "Bilaspur",
//         "Chamba",
//         "Dharamshala",
//         "Hamirpur",
//         "Kangra",
//         "Kullu",
//         "Mandi",
//         "Palampur",
//         "Shimla",
//         "Solan",
//         "Una"
//     ],
//     "Jharkhand": [
//         "Bokaro",
//         "Chaibasa",
//         "Deoghar",
//         "Dhanbad",
//         "Dumka",
//         "Giridih",
//         "Hazaribagh",
//         "Jamshedpur",
//         "Ranchi"
//     ],
//     "Karnataka": [
//         "Bagalkot",
//         "Ballari",
//         "Belagavi",
//         "Bengaluru",
//         "Bidar",
//         "Chikkamagaluru",
//         "Chitradurga",
//         "Davanagere",
//         "Hassan",
//         "Hubli",
//         "Kalaburagi",
//         "Mandya",
//         "Mangaluru",
//         "Mysuru",
//         "Raichur",
//         "Shivamogga",
//         "Tumakuru",
//         "Udupi"
//     ],
//     "Kerala": [
//         "Alappuzha",
//         // "Changanassery",
//         "Ernakulam",
//         "Idukki",
//         "Kannur",
//         "Kasaragod",
//         "Kochi",
//         "Kollam",
//         "Kottayam",
//         "Kozhikode",
//         "Malappuram",
//         "Palakkad",
//         "Pathanamthitta",
//         "Thiruvananthapuram",
//         "Thrissur",
//         "Wayanad"
//     ],
//     "Madhya Pradesh": [
//         "Bhopal",
//         "Burhanpur",
//         "Chhindwara",
//         "Dewas",
//         "Gwalior",
//         "Indore",
//         "Jabalpur",
//         "Katni",
//         "Khandwa",
//         "Ratlam",
//         "Rewa",
//         "Sagar",
//         "Satna",
//         "Ujjain"
//     ],
//     "Maharashtra": [
//         "Ahmednagar",
//         "Akola",
//         "Amravati",
//         "Aurangabad",
//         "Bhiwandi",
//         "Chandrapur",
//         "Dhule",
//         "Jalgaon",
//         "Kolhapur",
//         "Latur",
//         "Mumbai",
//         "Nagpur",
//         "Nanded",
//         "Nashik",
//         "Navi Mumbai",
//         "Pune",
//         "Solapur",
//         "Thane",
//         "Ulhasnagar"
//     ],
//     "Odisha": [
//         "Balasore",
//         "Baripada",
//         "Berhampur",
//         "Bhadrak",
//         "Bhubaneswar",
//         "Cuttack",
//         "Jeypore",
//         "Koraput",
//         "Puri",
//         "Rourkela",
//         "Sambalpur"
//     ],
//     "Punjab": [
//         "Amritsar",
//         "Bathinda",
//         "Firozpur",
//         "Hoshiarpur",
//         "Jalandhar",
//         "Ludhiana",
//         "Moga",
//         "Mohali",
//         "Pathankot",
//         "Patiala",
//         "Sangrur"
//     ],
//     "Rajasthan": [
//         "Ajmer",
//         "Alwar",
//         "Bharatpur",
//         "Bhilwara",
//         "Bikaner",
//         "Churu",
//         "Jaipur",
//         "Jodhpur",
//         "Kota",
//         "Pali",
//         "Sikar",
//         "Udaipur"
//     ],
//     "Tamil Nadu": [
//         "Chennai",
//         "Coimbatore",
//         "Cuddalore",
//         "Dindigul",
//         "Erode",
//         "Hosur",
//         "Kanchipuram",
//         "Karur",
//         "Madurai",
//         "Nagercoil",
//         "Salem",
//         "Thanjavur",
//         "Thoothukudi",
//         "Tirunelveli",
//         "Tiruppur",
//         "Trichy",
//         "Vellore"
//     ],
//     "Telangana": [
//         "Adilabad",
//         "Hyderabad",
//         "Karimnagar",
//         "Khammam",
//         "Mahbubnagar",
//         "Nalgonda",
//         "Nizamabad",
//         "Ramagundam",
//         "Warangal"
//     ],
//     "Uttar Pradesh": [
//         "Agra",
//         "Aligarh",
//         "Allahabad",
//         "Bareilly",
//         "Faizabad",
//         "Ghaziabad",
//         "Gonda",
//         "Gorakhpur",
//         "Jhansi",
//         "Kanpur",
//         "Lucknow",
//         "Mathura",
//         "Meerut",
//         "Moradabad",
//         "Noida",
//         "Rampur",
//         "Saharanpur",
//         "Sitapur",
//         "Varanasi"
//     ],
//     "West Bengal": [
//         "Asansol",
//         "Baharampur",
//         "Bardhaman",
//         "Durgapur",
//         "Haldia",
//         "Howrah",
//         "Kharagpur",
//         "Kolkata",
//         "Malda",
//         "Siliguri"
//     ]
// }


export const stateCityData = {
    "Andaman and Nicobar": [
        "Diglipur",
        "Nicobar",
        "South Andaman"
    ],
    "Andhra Pradesh": [
        "Addanki",
        "Adoni",
        "Akividu",
        "Anakapalle",
        "Anantapur",
        "Atmakur",
        "Attili",
        "Avanigadda",
        "Badvel",
        "Bapatla",
        "Betamcherla",
        "Bhattiprolu",
        "Bhimavaram",
        "Bobbili",
        "Chirala",
        "Chittoor",
        "Chodavaram",
        "Cumbum",
        "Dharmavaram",
        "Dhone",
        "Eluru",
        "Gannavaram",
        "Giddalur",
        "Gokavaram",
        "Gooty",
        "Gorantla",
        "Gudivada",
        "Gudlavalleru",
        "Gudur",
        "Guntakal",
        "Guntur",
        "Hindupur",
        "Ichchapuram",
        "Jammalamadugu",
        "Kadiri",
        "Kakinada",
        "Kalyandurg",
        "Kamalapuram",
        "Kandukur",
        "Kanigiri",
        "Kankipadu",
        "Kasibugga",
        "Kavali",
        "Kosigi",
        "Kovvur",
        "Kuppam",
        "Kurnool",
        "Macherla",
        "Machilipatnam",
        "Madanapalle",
        "Mandapeta",
        "Mandasa",
        "Mangalagiri",
        "Markapur",
        "Nandigama",
        "Nandikotkur",
        "Nandyal",
        "Narasannapeta",
        "Narasaraopet",
        "Narayanavanam",
        "Narsipatnam",
        "Nellimarla",
        "Nellore",
        "Ongole",
        "Pakala",
        "Palakollu",
        "Palasa",
        "Pedana",
        "Peddapuram",
        "Penugonda",
        "Penukonda",
        "Phirangipuram",
        "Piduguralla",
        "Pileru",
        "Pithapuram",
        "Podili",
        "Polavaram",
        "Ponnur",
        "Proddatur",
        "Puttaparthi",
        "Puttur",
        "Rajahmundry",
        "Ramachandrapuram",
        "Ramapuram",
        "Rampachodavaram",
        "Razam",
        "Razole",
        "Renigunta",
        "Repalle",
        "Salur",
        "Sattenapalle",
        "Singarayakonda",
        "Sompeta",
        "Srikakulam",
        "Srikalahasti",
        "Tadepalle",
        "Tanuku",
        "Tekkali",
        "Tirupati",
        "Tuni",
        "Uravakonda",
        "Venkatagiri",
        "Vetapalem",
        "Vijayawada",
        "Vinukonda",
        "Visakhapatnam",
        "Vizianagaram",
        "Vuyyuru",
        "Yanam"
    ],
    "Arunachal Pradesh": [
        "Anjaw",
        "Basar",
        "Bomdila",
        "Changlang",
        "Daporijo",
        "Dibang Valley",
        "East Siang",
        "Hayuliang",
        "Itanagar",
        "Khonsa",
        "Kurung Kumey",
        "Naharlagun",
        "Namsai",
        "Pasighat",
        "Roing",
        "Seppa",
        "Tawang",
        "Tezu",
        "Upper Siang",
        "Ziro"
    ],
    "Assam": [
        "Abhayapuri",
        "Amguri",
        "Baksa",
        "Barpathar",
        "Barpeta",
        "Barpeta Road",
        "Bijni",
        "Bilasipara",
        "Bokajan",
        "Bokakhat",
        "Bongaigaon",
        "Chabua",
        "Chirang",
        "Darrang",
        "Dhekiajuli",
        "Dhemaji",
        "Dhubri",
        "Dibrugarh",
        "Diphu",
        "Dispur",
        "Goalpara",
        "Gohpur",
        "Golaghat",
        "Golakganj",
        "Guwahati",
        "Haflong",
        "Hailakandi",
        "Hajo",
        "Hojai",
        "Jorhat",
        "Kamrup",
        "Kamrup Metropolitan",
        "Karbi Anglong",
        "Karimganj",
        "Kokrajhar",
        "Lakhipur",
        "Mankachar",
        "Margherita",
        "Morigaon",
        "Nagaon",
        "Nalbari",
        "Namrup",
        "North Lakhimpur",
        "Rangapara",
        "Rangia",
        "Sarupathar",
        "Silapathar",
        "Silchar",
        "Sonitpur",
        "Sorbhog",
        "Tangla",
        "Tezpur",
        "Tinsukia",
        "Udalguri",
        "Aujuri No.3"
    ],
    "Bihar": [
        "Araria",
        "Areraj",
        "Arrah",
        "Arwal",
        "Aurangabad",
        "Bagaha",
        "Baisi",
        "Bakhtiyarpur",
        "Bangaon",
        "Banka",
        "Banmankhi",
        "Barbigha",
        "Barh",
        "Bariarpur",
        "Begusarai",
        "Belsand",
        "Bettiah",
        "Bhagalpur",
        "Bhawanipur",
        "Bhojpur",
        "Bihar Sharif",
        "Bihariganj",
        "Bikramganj",
        "Birpur",
        "Bodhgaya",
        "Buxar",
        "Chakia",
        "Chapra",
        "Chhatapur",
        "Dalsingh Sarai",
        "Darbhanga",
        "Daudnagar",
        "Dehri",
        "Dhaka",
        "Dighwara",
        "Dumraon",
        "Gaya",
        "Gopalganj",
        "Hajipur",
        "Hilsa",
        "Hisua",
        "Jainagar",
        "Jamui",
        "Jhajha",
        "Jhanjharpur",
        "Kantai",
        "Katihar",
        "Khagaria",
        "Kharagpur",
        "Kishanganj",
        "Lalganj",
        "Madhepura",
        "Madhubani",
        "Mairwa",
        "Makhdumpur",
        "Maner",
        "Mirganj",
        "Munger",
        "Murliganj",
        "Muzaffarpur",
        "Nabinagar",
        "Nalanda",
        "Nasriganj",
        "Naubatpur",
        "Nawada",
        "Nirmali",
        "Nokha",
        "Patna",
        "Piro",
        "Pupri",
        "Rafiganj",
        "Rajgir",
        "Ramnagar",
        "Raxaul",
        "Revelganj",
        "Saharsa",
        "Samastipur",
        "Sasaram",
        "Shahpur",
        "Sheikhpura",
        "Sheohar",
        "Sherghati",
        "Silao",
        "Sitamarhi",
        "Siwan",
        "Supaul",
        "Teghra",
        "Tekari",
        "Vaishali",
        "Warisaliganj"
    ],
    "Chandigarh": [
        "Chandigarh"
    ],
    "Chhattisgarh": [
        "Akaltara",
        "Ambikapur",
        "Baikunthpur",
        "Balod",
        "Baloda Bazar",
        "Bhilai",
        "Bijapur",
        "Bilaspur",
        "Champa",
        "Chhuikhadan",
        "Dantewada",
        "Deori",
        "Dhamtari",
        "Dongargaon",
        "Durg",
        "Gariaband",
        "Gharghoda",
        "Jagdalpur",
        "Janjgir",
        "Jashpur",
        "Jashpurnagar",
        "Kanker",
        "Katghora",
        "Kawardha",
        "Khairagarh",
        "Kharod",
        "Kharsia",
        "Kondagaon",
        "Korba",
        "Kota",
        "Kurud",
        "Lormi",
        "Mahasamund",
        "Manendragarh",
        "Mungeli",
        "Narayanpur",
        "Pandaria",
        "Patan",
        "Pathalgaon",
        "Pendra",
        "Pithora",
        "Raigarh",
        "Raipur",
        "Rajnandgaon",
        "Ramanuj Ganj",
        "Ratanpur",
        "Sakti",
        "Saraipali",
        "Simga",
        "Surguja",
        "Takhatpur"
    ],
    "Dadra And Nagar Haveli": [
        "Daman",
        "Diu",
        "Silvassa"
    ],
    "Daman And Diu": [
        "Daman",
        "Diu",
        "Silvassa"
    ],
    "Delhi": [
        "Bawana",
        "Central Delhi",
        "East Delhi",
        "New Delhi",
        "North Delhi",
        "North East Delhi",
        "North West Delhi",
        "Rohini",
        "South Delhi",
        "South West Delhi",
        "West Delhi"
    ],
    "Goa": [
        "Bicholim",
        "Canacona",
        "Curchorem",
        "Mapusa",
        "Mormugao",
        "North Goa",
        "Pernem",
        "Ponda",
        "Quepem",
        "Sanguem",
        "Sanquelim",
        "Vasco Da Gama",
        "6 Amp"
    ],
    "Gujarat": [
        "Ahmedabad",
        "Ahwa",
        "Amod",
        "Amreli",
        "Anand",
        "Anjar",
        "Anklav",
        "Ankleshwar",
        "Babra",
        "Balasinor",
        "Banaskantha",
        "Bardoli",
        "Bavla",
        "Bhachau",
        "Bhanvad",
        "Bharuch",
        "Bhavnagar",
        "Bhuj",
        "Bilimora",
        "Borsad",
        "Botad",
        "Chanasma",
        "Chhota Udepur",
        "Chikhli",
        "Chotila",
        "Dabhoi",
        "Dahegam",
        "Dahod",
        "Dakor",
        "Danta",
        "Deesa",
        "Detroj",
        "Dhandhuka",
        "Dhanera",
        "Dhansura",
        "Dharampur",
        "Dhari",
        "Dhasa",
        "Dholera",
        "Dholka",
        "Dhoraji",
        "Dhrangadhra",
        "Dhrol",
        "Dohad",
        "Dungarpur",
        "Gadhada",
        "Gandevi",
        "Gandhidham",
        "Gandhinagar",
        "Ghogha",
        "Gir Somnath",
        "Godhra",
        "Gondal",
        "Halol",
        "Halvad",
        "Hansot",
        "Himatnagar",
        "Idar",
        "Jalalpore",
        "Jalalpur",
        "Jambusar",
        "Jamnagar",
        "Jasdan",
        "Jetpur",
        "Jhalod",
        "Jodhpur",
        "Junagadh",
        "Kadi",
        "Kalavad",
        "Kalol",
        "Kandla",
        "Kapadvanj",
        "Karjan",
        "Keshod",
        "Khambhalia",
        "Khambhat",
        "Kheda",
        "Khedbrahma",
        "Kheralu",
        "Kodinar",
        "Kothara",
        "Kutch",
        "Kutiyana",
        "Lakhpat",
        "Lalpur",
        "Lathi",
        "Limbdi",
        "Limkheda",
        "Mahudha",
        "Mahuva",
        "Malpur",
        "Manavadar",
        "Mandal",
        "Mandvi",
        "Mangrol",
        "Mansa",
        "Meghraj",
        "Mehsana",
        "Mendarda",
        "Modasa",
        "Morbi",
        "Morva Hadaf",
        "Mundra",
        "Nadiad",
        "Naliya",
        "Narmada",
        "Navsari",
        "Nizar",
        "Okha",
        "Olpad",
        "Padra",
        "Palanpur",
        "Palitana",
        "Palsana",
        "Pardi",
        "Patan",
        "Patdi",
        "Pavijetpur",
        "Petlad",
        "Porbandar",
        "Prantij",
        "Radhanpur",
        "Rajkot",
        "Rajpipla",
        "Rajula",
        "Ranavav",
        "Ranpur",
        "Rapar",
        "Roha",
        "Sanand",
        "Sankheda",
        "Sathamba",
        "Savar Kundla",
        "Savli",
        "Sayla",
        "Shahpur",
        "Shivrajpur",
        "Siddhpur",
        "Sihor",
        "Sinor",
        "Sojitra",
        "Songadh",
        "Surat",
        "Surendranagar",
        "Sutrapada",
        "Talaja",
        "Talod",
        "Tankara",
        "Tharad",
        "Thasra",
        "Umarpada",
        "Umrala",
        "Umreth",
        "Una",
        "Unjha",
        "Upleta",
        "Vadali",
        "Vadgam",
        "Vadnagar",
        "Vadodara",
        "Vaghodia",
        "Vaghodia INA",
        "Vallabhipur",
        "Valsad",
        "Vansda",
        "Vanthli",
        "Vapi",
        "Veraval",
        "Vijapur",
        "Viramgam",
        "Virpur",
        "Visavadar",
        "Visnagar",
        "Vyara",
        "Wankaner"
    ],
    "Haryana": [
        "Ambala",
        "Bahadurgarh",
        "Barwala",
        "Bawal",
        "Bawani Khera",
        "Bhiwani",
        "Bilaspur",
        "Charkhi Dadri",
        "Chhachhrauli",
        "Dabwali",
        "Dharuhera",
        "Faridabad",
        "Farrukh Nagar",
        "Fatehabad",
        "Firozpur Jhirka",
        "Gharaunda",
        "Gohana",
        "Gorakhpur",
        "Gurugram",
        "Hansi",
        "Hasanpur",
        "Hisar",
        "Hodal",
        "Indri",
        "Jagadhri",
        "Jhajjar",
        "Jind",
        "Kaithal",
        "Kalanwali",
        "Kalayat",
        "Kalka",
        "Karnal",
        "Kurukshetra",
        "Ladwa",
        "Loharu",
        "Naraingarh",
        "Narnaul",
        "Narwana",
        "Nilokheri",
        "Nuh",
        "Palwal",
        "Panchkula",
        "Panipat",
        "Pataudi",
        "Pehowa",
        "Pundri",
        "Rania",
        "Ratia",
        "Rewari",
        "Rohtak",
        "Safidon",
        "Shahabad",
        "Sirsa",
        "Siwani",
        "Sohna",
        "Sonipat",
        "Thanesar",
        "Tohana",
        "Tosham",
        "Yamuna Nagar"
    ],
    "Himachal Pradesh": [
        "Arki",
        "Banjar",
        "Bilaspur",
        "Chamba",
        "Dalhousie",
        "Daulat Pur",
        "Ghumarwin",
        "Hamirpur",
        "Jubbal",
        "Kasauli",
        "Kinnaur",
        "Kotkhai",
        "Manali",
        "Mandi",
        "Nadaun",
        "Nagar",
        "Nahan",
        "Nalagarh",
        "Palampur",
        "Pandoh",
        "Paonta Sahib",
        "Rajgarh",
        "Rampur",
        "Rohru",
        "Sarkaghat",
        "Seoni",
        "Shimla",
        "Solan",
        "Sundarnagar",
        "Theog",
        "Una"
    ],
    "Jammu and Kashmir": [
        "Anantnag",
        "Bandipore",
        "Banihal",
        "Bijbehara",
        "Bishnah",
        "Doda",
        "Ganderbal",
        "Hiranagar",
        "Jammu",
        "Kathua",
        "Kishtwar",
        "Kulgam",
        "Kupwara",
        "Magam",
        "Nawanshahr",
        "Pattan",
        "Pulwama",
        "Qazigund",
        "Ramban",
        "Ramgarh",
        "Ramnagar",
        "Samba",
        "Srinagar",
        "Sumbal",
        "Tral",
        "Udhampur",
        "Uri"
    ],
    "Jharkhand": [
        "Bagra",
        "Barwadih",
        "Bermo",
        "Bokaro",
        "Bundu",
        "Chaibasa",
        "Chakradharpur",
        "Chakulia",
        "Chandil",
        "Chas",
        "Chatra",
        "Chiria",
        "Chitarpur",
        "Deogarh",
        "Dhanbad",
        "Dumka",
        "Garhwa",
        "Giridih",
        "Gobindpur",
        "Godda",
        "Gua",
        "Gumla",
        "Hazaribag",
        "Hazaribagh",
        "Jagannathpur",
        "Jamshedpur",
        "Jamtara",
        "Jugsalai",
        "Kandra",
        "Kanke",
        "Khunti",
        "Latehar",
        "Lohardaga",
        "Madhupur",
        "Manoharpur",
        "Muri",
        "Noamundi",
        "Pakur",
        "Palamu",
        "Patamda",
        "Pathardih",
        "Patratu",
        "Rajmahal",
        "Ramgarh",
        "Ranchi",
        "Sahibganj",
        "Saraikela",
        "Simdega",
        "Sini"
    ],
    "Karnataka": [
        "Afzalpur",
        "Aland",
        "Alur",
        "Anekal",
        "Ankola",
        "Arsikere",
        "Athani",
        "Aurad",
        "Badami",
        "Bagalkot",
        "Bagepalli",
        "Bailhongal",
        "Ballari",
        "Bangarapet",
        "Basavakalyan",
        "Belagavi",
        "Belur",
        "Bengaluru",
        "Bengaluru Rural",
        "Bengaluru Urban",
        "Bhadravati",
        "Bhalki",
        "Bhatkal",
        "Bidar",
        "Bilgi",
        "Challakere",
        "Channagiri",
        "Channapatna",
        "Chikkamagaluru",
        "Chikodi",
        "Chincholi",
        "Chintamani",
        "Chitradurga",
        "Devanahalli",
        "Dharwad",
        "Doddaballapura",
        "Gadag",
        "Gauribidanur",
        "Gokak",
        "Gubbi",
        "Gudibanda",
        "Hadagalli",
        "Haliyal",
        "Hampi",
        "Hangal",
        "Harpanahalli",
        "Hassan",
        "Haveri",
        "Heggadadevankote",
        "Hirekerur",
        "Hiriyur",
        "Holalkere",
        "Honnali",
        "Honnavar",
        "Hosadurga",
        "Hosapete",
        "Hoskote",
        "Hubballi",
        "Hungund",
        "Hunsur",
        "Indi",
        "Jamkhandi",
        "Jevargi",
        "Kadur",
        "Kalghatgi",
        "Kamalapuram",
        "Kanakapura",
        "Karkala",
        "Karwar",
        "Khanapur",
        "Kodagu",
        "Kolar",
        "Kollegal",
        "Koppa",
        "Koppal",
        "Koratagere",
        "Kotturu",
        "Kudligi",
        "Kumta",
        "Kundapura",
        "Kundgol",
        "Kunigal",
        "Kushtagi",
        "Lingsugur",
        "Londa",
        "Maddur",
        "Madhugiri",
        "Madikeri",
        "Magadi",
        "Malavalli",
        "Malur",
        "Mandya",
        "Mangaluru",
        "Manipal",
        "Manvi",
        "Muddebihal",
        "Mudhol",
        "Mulbagal",
        "Mundargi",
        "Mundgod",
        "Mysuru",
        "Nagamangala",
        "Narasimharajapura",
        "Nargund",
        "Navalgund",
        "Nelamangala",
        "Puttur",
        "Raichur",
        "Ramanagara",
        "Ranebennur",
        "Sagar",
        "Sakleshpur",
        "Sandur",
        "Saundatti",
        "Savanur",
        "Sedam",
        "Shahabad",
        "Shahpur",
        "Shiggaon",
        "Shikarpur",
        "Shimoga",
        "Shorapur",
        "Shrirangapattana",
        "Siddapur",
        "Sidlaghatta",
        "Sira",
        "Sirsi",
        "Siruguppa",
        "Someshwar",
        "Sringeri",
        "Srinivaspur",
        "Tarikere",
        "Tiptur",
        "Tumakuru",
        "Turuvekere",
        "Udupi",
        "Vijayapura",
        "Virajpet",
        "Yadgir",
        "Yelandur",
        "Yellapur"
    ],
    "Kerala": [
        "Adoor",
        "Alappuzha",
        "Aluva",
        "Chengannur",
        "Cherpulassery",
        "Cherthala",
        "Ernakulam",
        "Idukki",
        "Irinjalakuda",
        "Kanhangad",
        "Kannapuram",
        "Kannur",
        "Karthikappally",
        "Kasaragod",
        "Kayamkulam",
        "Kochi",
        "Kodungallur",
        "Kollam",
        "kottakkal",
        "Kottayam",
        "Kovalam",
        "Koyilandy",
        "Kozhikode",
        "Mahe",
        "Malappuram",
        "Manjeri",
        "Muvattupuzha",
        "Nedumangad",
        "Neyyattinkara",
        "Nilambur",
        "Palakkad",
        "Pathanamthitta",
        "Payyanur",
        "Ponnani",
        "Ramanattukara",
        "Taliparamba",
        "Thalassery",
        "Thiruvananthapuram",
        "Thodupuzha",
        "Thrissur",
        "Tirur",
        "Tirurangadi"
    ],
    "Ladakh": [
        "Kargil",
        "Leh"
    ],
    "Lakshadweep": [
        "Lakshadweep"
    ],
    "Madhya Pradesh": [
        "Agar",
        "Akodia",
        "Alirajpur",
        "Amarpatan",
        "Amarwara",
        "Ambah",
        "Amla",
        "Anjad",
        "Anuppur",
        "Ashok Nagar",
        "Ashta",
        "Bada Malhera",
        "Badnawar",
        "Bagli",
        "Baihar",
        "Baikunthpur",
        "Balaghat",
        "Banda",
        "Barghat",
        "Barhi",
        "Barnagar",
        "Barwani",
        "Beohari",
        "Betul",
        "Bhainsdehi",
        "Bhander",
        "Bhanpura",
        "Bhikangaon",
        "Bhind",
        "Bhitarwar",
        "Bhopal",
        "Biaora",
        "Bijawar",
        "Budhni",
        "Burhanpur",
        "Burhar",
        "Chanderi",
        "Chhatarpur",
        "Chhindwara",
        "Churhat",
        "Daboh",
        "Dabra",
        "Damoh",
        "Datia",
        "Depalpur",
        "Dewas",
        "Dhana",
        "Dhar",
        "Dharampuri",
        "Dindori",
        "Gadarwara",
        "Garhakota",
        "Ghansor",
        "Gohad",
        "Guna",
        "Gwalior",
        "Harda",
        "Harrai",
        "Hatta",
        "Hoshangabad",
        "Ichhawar",
        "Indore",
        "Isagarh",
        "Itarsi",
        "Jabalpur",
        "Jaisinghnagar",
        "Jaithari",
        "Jaora",
        "Jatara",
        "Jawad",
        "Jhabua",
        "Jirapur",
        "Kailaras",
        "Kannod",
        "Kareli",
        "Karera",
        "Kasrawad",
        "Katangi",
        "Katni",
        "Khachrod",
        "Khandwa",
        "Khargapur",
        "Khargone",
        "Khategaon",
        "Khilchipur",
        "Khirkiya",
        "Khujner",
        "Khurai",
        "Kolaras",
        "Kotma",
        "Kukshi",
        "Kumbhraj",
        "Lahar",
        "Lakhnadon",
        "Machalpur",
        "Madhogarh",
        "Maheshwar",
        "Maihar",
        "Malhargarh",
        "Manasa",
        "Manawar",
        "Mandla",
        "Mandsaur",
        "Mau",
        "Mihona",
        "Morena",
        "Multai",
        "Mundi",
        "Mungaoli",
        "Nagda",
        "Nagod",
        "Nainpur",
        "Narwar",
        "Neemuch",
        "Nepanagar",
        "Nowgong",
        "Palera",
        "Pali",
        "Pandhana",
        "Pandhurna",
        "Panna",
        "Pansemal",
        "Parasia",
        "Patan",
        "Patharia",
        "Petlawad",
        "Piploda",
        "Porsa",
        "Raghogarh",
        "Rahatgarh",
        "Raisen",
        "Rajgarh",
        "Rajnagar",
        "Ranapur",
        "Ratangarh",
        "Ratlam",
        "Rehli",
        "Rehti",
        "Rewa",
        "Sabalgarh",
        "Sagar",
        "Sailana",
        "Sanwer",
        "Sarangpur",
        "Satna",
        "Sausar",
        "Sehore",
        "Sendhwa",
        "Seondha",
        "Seoni",
        "Seoni Malwa",
        "Shahdol",
        "Shahpur",
        "Shahpura",
        "Shajapur",
        "Sheopur",
        "Shivpuri",
        "Shujalpur",
        "Sidhi",
        "Sihora",
        "Simaria",
        "Singrauli",
        "Sirmaur",
        "Sironj",
        "Sitamau",
        "Sohagpur",
        "Sultanpur",
        "Susner",
        "Talen",
        "Tarana",
        "Tendukheda",
        "Teonthar",
        "Thandla",
        "Tikamgarh",
        "Tirodi",
        "Udaipura",
        "Ujjain",
        "Umaria",
        "Vidisha",
        "Waraseoni"
    ],
    "Maharashtra": [
        "Achalpur",
        "Aheri",
        "Ajara",
        "Akluj",
        "Akola",
        "Akot",
        "Alibag",
        "Amalner",
        "Ambad",
        "Ambajogai",
        "Ambegaon",
        "Amgaon",
        "Amravati",
        "Anjangaon",
        "Ardhapur",
        "Arvi",
        "Ashta",
        "Ashti",
        "Aurangabad",
        "Ausa",
        "Badlapur",
        "Badnapur",
        "Balapur",
        "Baramati",
        "Barshi",
        "Basmat",
        "Beed",
        "Bhandara",
        "Bhiwandi",
        "Bhiwapur",
        "Bhokar",
        "Bhokardan",
        "Bhoom",
        "Bhusawal",
        "Biloli",
        "Chakur",
        "Chalisgaon",
        "Chandgad",
        "Chandrapur",
        "Chandur",
        "Chandur Bazar",
        "Chikhli",
        "Chimur",
        "Chiplun",
        "Chopda",
        "Dahanu",
        "Dapoli",
        "Darwha",
        "Daund",
        "Deoni",
        "Desaiganj",
        "Dharangaon",
        "Dharmabad",
        "Dharur",
        "Dhule",
        "Digras",
        "Dombivli",
        "Durgapur",
        "Erandol",
        "Gadchiroli",
        "Gadhinglaj",
        "Ghatanji",
        "Gondia",
        "Goregaon",
        "Guhagar",
        "Hadgaon",
        "Hinganghat",
        "Hingoli",
        "Indapur",
        "Jalgaon",
        "Jalgaon Jamod",
        "Jalkot",
        "Jalna",
        "Jamkhed",
        "Jawhar",
        "Jintur",
        "Junnar",
        "Kadegaon",
        "Kagal",
        "Kaij",
        "Kalamb",
        "Kalamnuri",
        "Kalyan",
        "Kamptee",
        "Kannad",
        "Karad",
        "Karanja",
        "Karjat",
        "Karmala",
        "Katol",
        "Khalapur",
        "Khamgaon",
        "Khanapur",
        "Khandala",
        "Kharghar",
        "Khopoli",
        "Khuldabad",
        "Kinwat",
        "Kolhapur",
        "Kopargaon",
        "Koregaon",
        "Kudal",
        "Kuhi",
        "Lakhandur",
        "Lanja",
        "Latur",
        "Lonar",
        "Mahabaleshwar",
        "Mahad",
        "Malegaon",
        "Malkapur",
        "Malvan",
        "Manchar",
        "Mandangad",
        "Mangaon",
        "Mangrulpir",
        "Manwath",
        "Maregaon",
        "Matheran",
        "Mehkar",
        "Miraj",
        "Mohadi",
        "Mohol",
        "Mudkhed",
        "Mumbai",
        "Mumbai Suburban",
        "Murbad",
        "Nagpur",
        "Nala Sopara",
        "Nanded",
        "Nandura",
        "Nandurbar",
        "Narkhed",
        "Nashik",
        "Navapur",
        "Navi Mumbai",
        "Nilanga",
        "Niphad",
        "Osmanabad",
        "Pachora",
        "Paithan",
        "Palghar",
        "Pandharpur",
        "Panhala",
        "Panvel",
        "Paranda",
        "Parbhani",
        "Parner",
        "Parola",
        "Partur",
        "Patan",
        "Pathardi",
        "Pauni",
        "Peint",
        "Pen",
        "Phaltan",
        "Phulambri",
        "Pimpri-Chinchwad",
        "Pulgaon",
        "Pune",
        "Purna",
        "Pusad",
        "Radhanagari",
        "Rahata",
        "Rahuri",
        "Raigarh",
        "Rajapur",
        "Rajgurunagar",
        "Rajura",
        "Ralegaon",
        "Ramtek",
        "Ratnagiri",
        "Raver",
        "Risod",
        "Roha",
        "Sakoli",
        "Sakri",
        "Samudrapur",
        "Sangameshwar",
        "Sangamner",
        "Sangli",
        "Sangola",
        "Saoli",
        "Saswad",
        "Satana",
        "Satara",
        "Selu",
        "Shahada",
        "Shahapur",
        "Shegaon",
        "Shevgaon",
        "Shirala",
        "Shirol",
        "Shirpur",
        "Shirwal",
        "Shivaji Nagar",
        "Shrigonda",
        "Shrirampur",
        "Sillod",
        "Sindewahi",
        "Sindhudurg",
        "Sindkhed Raja",
        "Sindkheda",
        "Sinnar",
        "Sironcha",
        "Solapur",
        "Soygaon",
        "Surgana",
        "Taloda",
        "Tarapur",
        "Tasgaon",
        "Telhara",
        "Thane",
        "Trimbak",
        "Tuljapur",
        "Tumsar",
        "Udgir",
        "Umarkhed",
        "Umred",
        "Vaijapur",
        "Vengurla",
        "Virar",
        "Wadwani",
        "Wai",
        "Wani",
        "Wardha",
        "Warora",
        "Warud",
        "Washim",
        "Yavatmal",
        "Yeola"
    ],
    "Manipur": [
        "Bishnupur",
        "Chandel",
        "Churachandpur",
        "Imphal East",
        "Imphal West",
        "Jiribam",
        "Kakching",
        "Kamjong",
        "Kangpokpi",
        "Noney",
        "Pherzawl",
        "Senapati",
        "Tamenglong",
        "Tengnoupal",
        "Thoubal",
        "Ukhrul"
    ],
    "Meghalaya": [
        "Ampati",
        "Baghmara",
        "Jowai",
        "Khliehriat",
        "Mairang",
        "Nongpoh",
        "Nongstoin",
        "Resubelpara",
        "Ri Bhoi",
        "Shillong",
        "South West Garo Hills",
        "South West Khasi Hills",
        "Tura",
        "West Garo Hills",
        "Williamnagar"
    ],
    "Mizoram": [
        "Aizawl",
        "Champhai",
        "Darlawn",
        "Khawzawl",
        "Kolasib",
        "Lawngtlai",
        "Lunglei",
        "Mamit",
        "Sairang",
        "Serchhip"
    ],
    "Nagaland": [
        "Dimapur",
        "Kohima",
        "Mokokchung",
        "Mon",
        "Peren",
        "Phek",
        "Tuensang",
        "Wokha",
        "Zunheboto"
    ],
    "Odisha": [
        "Angul",
        "Asika",
        "Athagarh",
        "Athmallik",
        "Balangir",
        "Balasore",
        "Banapur",
        "Banki",
        "Barbil",
        "Bargarh",
        "Baripada",
        "Barpali",
        "Basudebpur",
        "Belpahar",
        "Bhadrak",
        "Bhanjanagar",
        "Bhawanipatna",
        "Bhuban",
        "Bhubaneswar",
        "Birmitrapur",
        "Brahmapur",
        "Buguda",
        "Burla",
        "Champua",
        "Chandbali",
        "Chikiti",
        "Cuttack",
        "Deogarh",
        "Dhamanagar",
        "Dhenkanal",
        "Digapahandi",
        "Ganjam",
        "Gopalpur",
        "Gudari",
        "Gunupur",
        "Hirakud",
        "Jagatsinghpur",
        "Jajpur",
        "Jaleshwar",
        "Jeypore",
        "Jharsuguda",
        "Junagarh",
        "Kamakhyanagar",
        "Kandhamal",
        "Kantabanji",
        "Karanjia",
        "Kendrapara",
        "Kendujhar",
        "Kesinga",
        "Khallikot",
        "Khordha",
        "Kiriburu",
        "Kodala",
        "Koraput",
        "Kuchinda",
        "Malkangiri",
        "Nayagarh",
        "Nilagiri",
        "Nuapada",
        "Paralakhemundi",
        "Patnagarh",
        "Phulbani",
        "Pipili",
        "Puri",
        "Purushottampur",
        "Rairangpur",
        "Rajgangpur",
        "Rambha",
        "Rayagada",
        "Remuna",
        "Rengali",
        "Rourkela",
        "Sambalpur",
        "Sonepur",
        "Soro",
        "Subarnapur",
        "Sunabeda",
        "Sundargarh",
        "Talcher",
        "Udayagiri"
    ],
    "Puducherry": [
        "Karaikal",
        "Mahe",
        "Puducherry",
        "Villianur",
        "Yanam"
    ],
    "Punjab": [
        "Abohar",
        "Ajnala",
        "Amloh",
        "Amritsar",
        "Anandpur Sahib",
        "Bagha Purana",
        "Barnala",
        "Batala",
        "Bholath",
        "Budhlada",
        "Dasuya",
        "Dera Baba Nanak",
        "Dera Bassi",
        "Dhariwal",
        "Dhilwan",
        "Dhuri",
        "Doraha",
        "Faridkot",
        "Fatehgarh Sahib",
        "Fazilka",
        "Firozpur",
        "Garhshankar",
        "Gurdaspur",
        "Hajipur",
        "Hoshiarpur",
        "Jagraon",
        "Jaito",
        "Jalalabad",
        "Jalandhar",
        "Jandiala Guru",
        "Kapurthala",
        "Khamanon",
        "Khanna",
        "Kharar",
        "Khem Karan",
        "Kot Kapura",
        "Kurali",
        "Lehragaga",
        "Ludhiana",
        "Majitha",
        "Malerkotla",
        "Malout",
        "Mansa",
        "Moga",
        "Mohali",
        "Moonak",
        "Mukerian",
        "Nabha",
        "Nakodar",
        "Nangal",
        "Nawanshahr",
        "Pathankot",
        "Patiala",
        "Patti",
        "Phagwara",
        "Phillaur",
        "Raikot",
        "Raja Sansi",
        "Rajpura",
        "Rupnagar",
        "Samrala",
        "Sangrur",
        "Sardulgarh",
        "Shahkot",
        "Sri Muktsar Sahib",
        "Sultanpur Lodhi",
        "Sunam",
        "Zira"
    ],
    "Rajasthan": [
        "Abu Road",
        "Ajmer",
        "Alwar",
        "Amet",
        "Anupgarh",
        "Bali",
        "Balotra",
        "Banswara",
        "Baran",
        "Bari",
        "Bari Sadri",
        "Barmer",
        "Bayana",
        "Beawar",
        "Begun",
        "Behror",
        "Bhadra",
        "Bharatpur",
        "Bhilwara",
        "Bhinmal",
        "Bhiwadi",
        "Bikaner",
        "Bilara",
        "Bundi",
        "Chhoti Sadri",
        "Churu",
        "Dausa",
        "Didwana",
        "Dungarpur",
        "Fatehpur",
        "Hanumangarh",
        "Jaipur",
        "Jaisalmer",
        "Jaitaran",
        "Jalore",
        "Jhalawar",
        "Jodhpur",
        "Kaman",
        "Kapasan",
        "Karauli",
        "Kekri",
        "Khanpur",
        "Khetri",
        "Kota",
        "Kumher",
        "Ladnun",
        "LALSOT",
        "Makrana",
        "Mandal",
        "Mandalgarh",
        "Mandawar",
        "Mangrol",
        "Manoharpur",
        "Merta",
        "Mundwa",
        "Nadbai",
        "Nagar",
        "Nagaur",
        "Nasirabad",
        "Nathdwara",
        "Nawalgarh",
        "Neem Ka Thana",
        "Nimbahera",
        "Niwai",
        "Nohar",
        "Nokha",
        "Pali",
        "Phalodi",
        "Pilani",
        "Pindwara",
        "Pratapgarh",
        "Raipur",
        "Raisingh Nagar",
        "Rajakhera",
        "Rajgarh",
        "Rajsamand",
        "Ramgarh",
        "Ratangarh",
        "Rawatbhata",
        "Rawatsar",
        "Salumbar",
        "Samdari",
        "Sangaria",
        "Sarwar",
        "Sawai Madhopur",
        "Shahpura",
        "Sheoganj",
        "Sikar",
        "Sirohi",
        "Siwana",
        "Sojat",
        "Sri Ganganagar",
        "Sujangarh",
        "Surajgarh",
        "Suratgarh",
        "Taranagar",
        "Tijara",
        "Todabhim",
        "Tonk",
        "Udaipur",
        "Weir"
    ],
    "Sikkim": [
        "Gangtok",
        "Gyalshing",
        "Jorethang",
        "Mangan",
        "Namchi",
        "Rangpo",
        "Singtam"
    ],
    "Tamil Nadu": [
        "Alangudi",
        "Alangulam",
        "Alur",
        "Ambasamudram",
        "Ambur",
        "Andippatti",
        "Annavasal",
        "Arakkonam",
        "Arcot",
        "Ariyalur",
        "Aruppukkottai",
        "Attur",
        "Avadi",
        "Avinashi",
        "Bargur",
        "Belur",
        "Bhavani",
        "Chengalpattu",
        "Chengam",
        "Chennai",
        "Cheyyar",
        "Chidambaram",
        "Chinnasalem",
        "Coimbatore",
        "Coonoor",
        "Cuddalore",
        "Cumbum",
        "Devakottai",
        "Dharapuram",
        "Dharmapuri",
        "Dindigul",
        "Dusi",
        "Erode",
        "Ettaiyapuram",
        "Gandhinagar",
        "Gangavalli",
        "Gingee",
        "Gobichettipalayam",
        "Gudalur",
        "Harur",
        "Hosur",
        "Idappadi",
        "Jayamkondacholapuram",
        "Kadambur",
        "Kalavai",
        "Kamuthi",
        "Kanchipuram",
        "Kangayam",
        "Kariapatti",
        "Karur",
        "Katpadi",
        "Kattumannarkoil",
        "Kilvelur",
        "Kodaikanal",
        "Kotagiri",
        "Kovilpatti",
        "Krishnagiri",
        "Kumbakonam",
        "Kuttalam",
        "Kuzhithurai",
        "Lalgudi",
        "Madurai",
        "Madurantakam",
        "Mallapuram",
        "Mallasamudram",
        "Manali",
        "Manamadurai",
        "Manapparai",
        "Mannargudi",
        "Marakkanam",
        "Mayiladuthurai",
        "Melur",
        "Mettur",
        "Musiri",
        "Nagapattinam",
        "Nagercoil",
        "Namakkal",
        "Nanguneri",
        "Nannilam",
        "Natham",
        "Nilakottai",
        "Nilgiris",
        "Omalur",
        "Ooty",
        "Palani",
        "Palladam",
        "Pallipalayam",
        "Pallipattu",
        "Panruti",
        "Papanasam",
        "Pattukkottai",
        "Pennagaram",
        "Pennathur",
        "Peraiyur",
        "Perambalur",
        "Peravurani",
        "Periyakulam",
        "Perundurai",
        "Pollachi",
        "Polur",
        "Ponneri",
        "Pudukkottai",
        "Rajapalayam",
        "Ramanathapuram",
        "Rameswaram",
        "Ranipet",
        "Rasipuram",
        "Salem",
        "Sathankulam",
        "Sathyamangalam",
        "Sattur",
        "Sholavandan",
        "Sholinghur",
        "Singampunari",
        "Sirkazhi",
        "Sivaganga",
        "Sivagiri",
        "Sivakasi",
        "Sriperumbudur",
        "Srivaikuntam",
        "Srivilliputhur",
        "Thanjavur",
        "Tharangambadi",
        "Theni",
        "Thiruthani",
        "Thiruthuraipoondi",
        "Thiruvaiyaru",
        "Thiruvarur",
        "Thiruvidaimaruthur",
        "Thoothukudi",
        "Tindivanam",
        "Tiruchengode",
        "Tiruchirappalli",
        "Tirunelveli",
        "Tiruppur",
        "Tiruppuvanam",
        "Tiruvannamalai",
        "Turaiyur",
        "Usilampatti",
        "Uttiramerur",
        "Vadipatti",
        "Valangaiman",
        "Valparai",
        "Vandavasi",
        "Vaniyambadi",
        "Vedasandur",
        "Vellore",
        "Velur",
        "Villupuram",
        "Virudhunagar",
        "Walajapet"
    ],
    "Telangana": [
        "Adilabad",
        "Asifabad",
        "Balapur",
        "Banswada",
        "Bhadrachalam",
        "Bhadradri Kothagudem",
        "Bodhan",
        "Chandur",
        "Dornakal",
        "Farrukh Nagar",
        "Gadwal",
        "Ghatkesar",
        "Gudur",
        "Hyderabad",
        "Jagtial",
        "Jangaon",
        "Jogipet",
        "Jogulamba Gadwal",
        "Kamareddy",
        "Karimnagar",
        "Khammam",
        "Kothakota",
        "Mahabubabad",
        "Mahbubnagar",
        "Mancherial",
        "Mandamarri",
        "Manthani",
        "Manuguru",
        "Medak",
        "Medchal",
        "Metpalle",
        "Miryalaguda",
        "Nalgonda",
        "Narayanpet",
        "Narsampet",
        "Nirmal",
        "Nizamabad",
        "Palwancha",
        "Peddapalli",
        "Rajanna Sircilla",
        "Ramagundam",
        "Sarapaka",
        "Secunderabad",
        "Siddipet",
        "Tandur",
        "Vikarabad",
        "Warangal",
        "Yellandu"
    ],
    "Tripura": [
        "Agartala",
        "Belonia",
        "Dhalai",
        "Dharmanagar",
        "Gomati",
        "Kailashahar",
        "Khowai",
        "North Tripura",
        "Ranirbazar",
        "Sonamura",
        "South Tripura",
        "Udaipur",
        "Unakoti",
        "West Tripura"
    ],
    "Uttar Pradesh": [
        "Agra",
        "Akbarpur",
        "Akola",
        "Aliganj",
        "Aligarh",
        "Ambedkar Nagar",
        "Amethi",
        "Amroha",
        "Anand Nagar",
        "Aonla",
        "Atrauli",
        "Auraiya",
        "Azamgarh",
        "Baghpat",
        "Bah",
        "Baheri",
        "Bahraich",
        "Bajna",
        "Ballia",
        "Balrampur",
        "Banda",
        "Bansdih",
        "Bansgaon",
        "Bansi",
        "Barabanki",
        "Baraut",
        "Bareilly",
        "Barkhera",
        "Basti",
        "Behat",
        "Bela",
        "Belthara",
        "Bewar",
        "Bhadohi",
        "Bharthana",
        "Bhinga",
        "Bhongaon",
        "Bidhnu",
        "Bidhuna",
        "Bijnor",
        "Bikapur",
        "Bilari",
        "Bilaspur",
        "Bilgram",
        "Bilhaur",
        "Bilsi",
        "Bisalpur",
        "Bisauli",
        "Biswan",
        "Budaun",
        "Budhana",
        "Bulandshahr",
        "Chail",
        "Chakia",
        "Chandauli",
        "Chandausi",
        "Chandpur",
        "Chhata",
        "Chirgaon",
        "Chitrakoot",
        "Chunar",
        "Colonelganj",
        "Dadri",
        "Dalmau",
        "Dataganj",
        "Deoband",
        "Deogarh",
        "Deoria",
        "Dhampur",
        "Dhan Ghata",
        "Dhanaura",
        "Dibai",
        "Etah",
        "Etawah",
        "Etmadpur",
        "Faizabad",
        "Faridpur",
        "Farrukhabad",
        "Fateh Garh",
        "Fatehabad",
        "Fatehpur",
        "Firozabad",
        "Gajraula",
        "Gangoh",
        "Garautha",
        "Gauriganj",
        "Gautam Buddha Nagar",
        "Ghatampur",
        "Ghaziabad",
        "Ghazipur",
        "Ghosi",
        "Gola Bazar",
        "Gola Gokaran Nath",
        "Gonda",
        "Gorakhpur",
        "Greater Noida",
        "Gunnaur",
        "Gyanpur",
        "Hamirpur",
        "Handia",
        "Hapur",
        "Haraipur",
        "Hardoi",
        "Hasanpur",
        "Hata",
        "Hathras",
        "Ikauna",
        "Indergarh",
        "Islam Nagar",
        "Jagdishpur",
        "Jalalabad",
        "Jalalpur",
        "Jalaun",
        "Jalesar",
        "Jansath",
        "Jarwa",
        "Jasrana",
        "Jaswant Nagar",
        "Jaunpur",
        "Jewar",
        "Jhansi",
        "Jhinjhak",
        "Kadipur",
        "Kairana",
        "Kakori",
        "Kalinagar",
        "Kalpi",
        "Kalyanpur",
        "Kannauj",
        "Kanpur",
        "Kanth",
        "Karari",
        "Karbigwan",
        "Karchana",
        "Karhal",
        "Kasganj",
        "Kaushambi",
        "Khairagarh",
        "Khalilabad",
        "Khanpur",
        "Kheri",
        "Khurja",
        "Kiraoli",
        "Konch",
        "Kota",
        "Kotra",
        "Kunda",
        "Kushinagar",
        "Laharpur",
        "Lakhimpur",
        "Lalganj",
        "Lalitpur",
        "Lambhua",
        "Lar",
        "Loni",
        "Lucknow",
        "Madhogarh",
        "Maharajganj",
        "Mahmudabad",
        "Mahoba",
        "Maholi",
        "Mainpuri",
        "Malihabad",
        "Mandawar",
        "Manikpur",
        "Manjhanpur",
        "Mankapur",
        "Mariahu",
        "Mathura",
        "Mau",
        "Mawana",
        "Meerut",
        "Mehnagar",
        "Milak",
        "Milkipur",
        "Mirganj",
        "Mirzapur",
        "Misrikh",
        "Mohanpur",
        "Moth",
        "Mungra Badshahpur",
        "Munsyari",
        "Muradnagar",
        "Musafirkhana",
        "Muzaffarnagar",
        "Nagina",
        "Najibabad",
        "Nakur",
        "Nanauta",
        "Nanpara",
        "Nautanwa",
        "Nawabganj",
        "Nichlaul",
        "Nizamabad",
        "Noida",
        "Nurpur",
        "Obra",
        "Orai",
        "Padrauna",
        "Pali",
        "Palia Kalan",
        "Patti",
        "Payagpur",
        "Phaphamau",
        "Phulpur",
        "Pilibhit",
        "Pratapgarh",
        "Pukhrayan",
        "Puranpur",
        "Purwa",
        "RaeBareli",
        "Rajapur",
        "Ramnagar",
        "Rampur",
        "Rasra",
        "Rasulabad",
        "Robertsganj",
        "Rudauli",
        "Rura",
        "Sachendi",
        "Sadabad",
        "Safipur",
        "Saharanpur",
        "Sahaswan",
        "Saidpur",
        "Salempur",
        "Salon",
        "Sambhal",
        "Sandila",
        "Sardhana",
        "Shahabad",
        "Shahganj",
        "Shahjahanpur",
        "Shahpur",
        "Shamli",
        "Shankargarh",
        "Shikarpur",
        "Shikohabad",
        "Shivrajpur",
        "Siddharth Nagar",
        "Sidhauli",
        "Sirathu",
        "Sirsa",
        "Sirsi",
        "Sitapur",
        "Suar",
        "Sultanpur",
        "Tajpur",
        "Tanda",
        "Thakurdwara",
        "Tilhar",
        "Tulsipur",
        "Unnao",
        "Utraula",
        "Varanasi",
        "Zamania"
    ],
    "Uttarakhand": [
        "Almora",
        "Bageshwar",
        "Barkot",
        "Bazpur",
        "Bhimtal",
        "Chakrata",
        "Chamoli",
        "Champawat",
        "Dehradun",
        "Devaprayag",
        "Dharchula",
        "Dwarahat",
        "Haldwani",
        "Haridwar",
        "Jaspur",
        "Joshimath",
        "Kaladhungi",
        "Kashipur",
        "Khatima",
        "Kichha",
        "Kotdwara",
        "Laksar",
        "Lansdowne",
        "Lohaghat",
        "Mussoorie",
        "Nainital",
        "Narendra Nagar",
        "Pauri",
        "Pithoragarh",
        "Raipur",
        "Ramnagar",
        "Ranikhet",
        "Rishikesh",
        "Roorkee",
        "Rudraprayag",
        "Rudrapur",
        "Sitarganj",
        "Srinagar",
        "Sultanpur",
        "Tanakpur",
        "Tehri",
        "Tehri Garhwal",
        "Udham Singh Nagar",
        "Uttarkashi",
        "Vikas Nagar"
    ],
    "West Bengal": [
        "Adra",
        "Ahmedpur",
        "Alipurduar",
        "Amta",
        "Amtala",
        "Andal",
        "Asansol",
        "Badkulla",
        "Baduria",
        "Balarampur",
        "Balichak",
        "Balurghat",
        "Bangaon",
        "Bankura",
        "Bansberia",
        "Barabazar",
        "Barasat",
        "Bardhaman",
        "Barjora",
        "Barrackpore",
        "Baruipur",
        "Basanti",
        "Basirhat",
        "Belda",
        "Beldanga",
        "Berhampore",
        "Bhatpara",
        "Bishnupur",
        "Bolpur",
        "Canning",
        "Chakdaha",
        "Champahati",
        "Chandannagar",
        "Chandrakona",
        "Contai",
        "Cooch Behar",
        "Darjeeling",
        "Daulat Pur",
        "Debagram",
        "Debipur",
        "Dhupguri",
        "Diamond Harbour",
        "Digha",
        "Dinhata",
        "Domjur",
        "Dubrajpur",
        "Durgapur",
        "Egra",
        "Falakata",
        "Farakka",
        "Gangarampur",
        "Garulia",
        "Ghatal",
        "Giria",
        "Gobardanga",
        "Gobindapur",
        "Gopalpur",
        "Gorubathan",
        "Gosaba",
        "Guskhara",
        "Habra",
        "Haldia",
        "Haldibari",
        "Haringhata",
        "Hooghly",
        "Howrah",
        "Ichapur",
        "Jalpaiguri",
        "Jamuria",
        "Jangipur",
        "Jhalida",
        "Jhargram",
        "Kakdwip",
        "Kaliaganj",
        "Kalimpong",
        "Kalna",
        "Kalyani",
        "Kanchrapara",
        "Katwa",
        "Kenda",
        "Kharagpur",
        "Kharar",
        "Kharba",
        "Kolkata",
        "Krishnanagar",
        "Kulpi",
        "Kurseong",
        "Lalgola",
        "Madanpur",
        "Mathabhanga",
        "Medinipur",
        "Memari",
        "Mirik",
        "Murshidabad",
        "Nabadwip",
        "Nabagram",
        "Nagrakata",
        "Naihati",
        "Nalhati",
        "Nandigram",
        "North 24 Parganas",
        "Panchla",
        "Pandua",
        "Panskura",
        "Purulia",
        "Raiganj",
        "Rajpur Sonarpur",
        "Ramnagar",
        "Rampurhat",
        "Ranaghat",
        "Raniganj",
        "Sainthia",
        "Santipur",
        "Sarenga",
        "Serampore",
        "Siliguri",
        "Singur",
        "Sonamukhi",
        "South 24 Parganas",
        "Sri Ram Pur",
        "Suri",
        "Taki",
        "Tamluk",
        "Tarakeswar",
        "Titagarh",
        "Tufanganj",
        "Tulin",
        "Uttarpara Kotrung"
    ]
}